import openSocket from 'socket.io-client';

export default openSocket(`${import.meta.env.VITE_SOCKET_URL}/messages`, {
  autoConnect: false,
  reconnection: true,
  secure: true,
  transports: ['websocket']
});
